<script setup>
import { ref, onServerPrefetch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import '../assets/styles/sanitize.css'
import '../assets/styles/app.css'
import SectionTitle from './SectionTitle.vue'
import { useGetData } from '../composable/useGetData.js'
import { useCommon } from '../composable/useCommon.js'
import { useGlobalHeader } from '../composable/useGlobalHeader.js'
import { useStore } from '../store.js'
const { isWebView } = useCommon()
const { addParams } = useGlobalHeader()

const store = useStore()
const { sideMenuList, snsList, memberMenuList } = storeToRefs(store)
const props = defineProps({
  sideMenuShowMember: { type: Boolean, default: false },
  devDomains: { type: Object, default: () => {} },
  appViewShow: { type: Boolean, default: true },
  isWebViewProp: { type: Boolean, default: false }
})

const isWebViewFlag = ref(props.isWebViewProp)


const { getSideMenuList, getSnsList, getMemberList } = useGetData(props.devDomains)

onServerPrefetch(async () => {
  sideMenuList.value = await getSideMenuList()
  snsList.value = await getSnsList()
  memberMenuList.value = await getMemberList()
})

onMounted(async () => {
  isWebViewFlag.value = isWebView()
  if (!sideMenuList.value) sideMenuList.value = await getSideMenuList()
  if (!snsList.value) snsList.value = await getSnsList()
  if (!memberMenuList.value) memberMenuList.value = await getMemberList()
})
</script>

<template>
  <section
    v-if="(!isWebViewFlag || appViewShow)"
    class="sideMenu"
  >
    <ul
      v-if="sideMenuList"
      class="contents"
    >
      <li
        v-for="menu in sideMenuList"
        :key="menu.title"
        class="block"
      >
        <SectionTitle
          :title="menu.title"
          :is-heading="false"
        />
        <ul class="inner">
          <li
            v-for="content in menu.contents"
            :key="content.text"
            class="menu"
          >
            <a
              :href="isWebViewFlag ? content.app_link : addParams(content.link, 'onebox')"
              class="link"
            >
              <img
                :src="content.icon"
                width="20"
                height="20"
                loading="lazy"
                class="icon"
                alt=""
              >
              <p class="text">{{ content.text }}</p>
            </a>
          </li>
        </ul>
        <slot
          :name="'ads-btf3_' + menu.title"
        />
      </li>
      <div v-if="sideMenuShowMember && memberMenuList?.contents">
        <SectionTitle
          :title="memberMenuList.title"
          :is-heading="false"
        />
        <ul class="member-inner">
          <li
            v-for="content in memberMenuList.contents"
            :key="content.text"
            class="member-menu"
          >
            <a
              :href="content.link"
              class="link"
            >
              <img
                :src="content.icon"
                width="20"
                height="20"
                loading="lazy"
                class="icon"
                alt=""
              >
              <p class="text">{{ content.text }}</p>
            </a>
          </li>
        </ul>
      </div>
    </ul>
    <div
      v-if="snsList?.contents && !isWebViewFlag"
      class="sns"
    >
      <SectionTitle
        :title="snsList.title"
        :is-heading="false"
      />
      <ul class="sns-inner">
        <li
          v-for="content in snsList.contents"
          :key="content.icon"
        >
          <a
            :href="content.link"
            class="sns-link"
          >
            <img
              :src="content.icon"
              width="43"
              height="43"
              loading="lazy"
              :alt="content.icon"
            >
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.sideMenu {
  .contents {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .inner {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    border-top: solid 1px #dfe4f0;
  }
  .menu {
    width: 50%;
    border-bottom: solid 1px #dfe4f0;
    &:not(:nth-child(2n)) {
      border-right: solid 1px #dfe4f0;
    }
  }
  .link {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 10px 3px 10px 5px;
  }
  .icon {
    width: 20px;
  }
  .text {
    color: #3569c0;
    font-size: 13px;
    font-weight: bold;
    line-height: 13px;
  }
  .member-inner {
    margin-top: 10px;
    border-top: solid 1px #dfe4f0;
  }
  .member-menu {
    width: 100%;
    border-bottom: solid 1px #dfe4f0;
  }
  .sns {
    margin-top: 30px;
    text-align: center;
    &-inner {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      margin-top: 15px;
    }
    &-link {
      display: block;
      width: 43px;
      height: 43px;
      border-radius: 3px;
      overflow: hidden;
    }
  }
  @media screen and (min-width: 830px) {
    .link {
      transition: background-color .2s ease-in-out;
      &:hover {
        background-color: rgba(#3569c0, .15);
      }
    }
    .sns {
      &-link {
        transition: opacity .2s ease-in-out;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
}
</style>
